'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { useMemo, useState, type JSX } from 'react';
import { FilterPill } from '@/components/molecules/FilterPill';
import { ArticleBox } from './partials/ArticleBox';
import { filterItemsByYear, getFilters, sortItemsByDate } from './utils';

/**
 * Props for `Articles`.
 */
export type ArticlesProps = SliceComponentProps<Content.ArticlesSlice>;

/**
 * Component for "Articles" Slices.
 */
const Articles = t0 => {
  const $ = _c(13);
  const {
    slice
  } = t0;
  let t1;
  if ($[0] !== slice.items) {
    t1 = sortItemsByDate(slice.items);
    $[0] = slice.items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortedItemsByDate = t1;
  const filters = getFilters(sortedItemsByDate);
  const [activeFilter, setActiveFilter] = useState(filters[0]);
  const filteredItems = filterItemsByYear(sortedItemsByDate, activeFilter);
  const t2 = slice.slice_type;
  const t3 = slice.variation;
  const t4 = "o-container o-container--xl my-44";
  const t5 = "Articles";
  const t6 = "index.tsx";
  let t7;
  if ($[2] !== activeFilter) {
    t7 = filter => <FilterPill key={filter} isActive={activeFilter === filter} label={filter} onClick={() => {
      setActiveFilter(filter);
    }} className="transition-all" />;
    $[2] = activeFilter;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = filters.map(t7);
  let t9;
  if ($[4] !== t8) {
    t9 = <div className="no-scrollbar mb-[3.75rem] flex flex-row gap-2 overflow-x-scroll">{t8}</div>;
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const t10 = "flex flex-wrap gap-x-5 gap-y-16";
  const t11 = filteredItems.map(_temp);
  let t12;
  if ($[6] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[6] = t11;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  let t13;
  if ($[8] !== slice.slice_type || $[9] !== slice.variation || $[10] !== t12 || $[11] !== t9) {
    t13 = <section data-slice-type={t2} data-slice-variation={t3} className={t4} data-sentry-component={t5} data-sentry-source-file={t6}>{t9}{t12}</section>;
    $[8] = slice.slice_type;
    $[9] = slice.variation;
    $[10] = t12;
    $[11] = t9;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  return t13;
};
export default Articles;
function _temp(item) {
  return <ArticleBox key={item.title} {...item} />;
}